import React, { Component } from 'react';
import Nprogress from 'nprogress';
import RouteAccess from 'bukku/components/Access/RouteAccess';

export default function asyncComponent(importComponent, { wrapper, wrapperProps }) {
    class AsyncFunc extends Component {
        constructor(props) {
            super(props);
            this.state = {
                Component: null,
                Wrapper: null,
                wrapperProps: {},
            };

            Nprogress.start();
        }

        async componentDidMount() {
            this.mounted = true;
            const { default: Component } = await importComponent();

            Nprogress.done();
            if (this.mounted) {
                this.setState({
                    Component,
                    Wrapper: wrapper || null,
                    wrapperProps: wrapperProps || {},
                });
            }
        }

        componentWillUnmount() {
            this.mounted = false;
        }

        render() {
            const { Component, Wrapper, wrapperProps } = this.state;

            if (Component) {
                return (
                    <RouteAccess>
                        {
                            Wrapper ? (
                                <Wrapper {...wrapperProps}>
                                    <Component {...this.props} {...wrapperProps} />
                                </Wrapper>
                            ) : (
                                <Component {...this.props} />
                            )
                        }
                    </RouteAccess>
                );
            }
            return null;
            //
            // return (
            //     <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
            //         {
            //             Component ? (
            //                 <RouteAccess>
            //                     <Component {...this.props} />
            //                     {/*<AutomatedUrlSwitcher/>*/}
            //                 </RouteAccess>
            //             )
            //                 : <div />
            //         }
            //     </ReactPlaceholder>
            // );
        }
    }
    return AsyncFunc;
}
